import * as React from 'react';
import { Async, FilterOptionsHandler, LoadOptionsAsyncHandler, OptionRendererHandler } from 'react-select';
import { text } from 'src/common/text';
import { SchoolOption } from 'src/domain/SchoolOption';

import { UNTIS_URL } from 'src/config';
import '../styles/Search.css';

export const SCHOOL_SEARCH_MIN_LENGTH = 3;

interface SearchBarProps {
  getSchools: LoadOptionsAsyncHandler<number>;
  selectSchool: (school: SchoolOption) => void;
}

export const Search: React.FC<SearchBarProps> = ({ getSchools: getSchoolsOriginal, selectSchool }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const getSchools: LoadOptionsAsyncHandler<number> = async (input) => {
    setIsLoading(true);
    const result = await getSchoolsOriginal(input);
    setIsLoading(false);
    return result;
  };

  const [isOpen, setIsOpen] = React.useState(false);
  const [isShort, setIsShort] = React.useState(true);
  const [isEmpty, setIsEmpty] = React.useState(true);
  const [key, setKey] = React.useState(0);
  const ref = React.useRef<any>();

  const renderOverlay = () => {
    const handleClear = () => {
      setKey(key + 1);
      setIsEmpty(true);
      setIsShort(true);
      // react-select is missing other solution to clear the whole input
    };

    return <>{!isEmpty && !isLoading && <ClearRender onClick={handleClear} />}</>;
  };

  return (
    <div className="search-wrapper">
      <Async
        {...{
          ref,
          key,
          menuContainerStyle: {
            backgroundColor: 'none',
          },
          onInputChange: (search) => {
            setIsShort(search.length < SCHOOL_SEARCH_MIN_LENGTH);
            setIsEmpty(search.length === 0);
            return search;
          },
          inputProps: {
            placeholder: '',
          },
          onOpen: () => setIsOpen(true),
          onClose: () => setIsOpen(false),
          className: `search${isShort ? ' is-empty' : ''}`,
          valueKey: 'id',
          labelKey: 'label',
          // cache: false,
          // autoload: false,
          autosize: false,
          autoFocus: true,
          ignoreAccents: false,
          onBlurResetsInput: false,
          onCloseResetsInput: false,
          placeholder: text('LBL_PLACEHOLDER'),
          // loadingPlaceholder: '',
          noResultsText: isShort
            ? undefined
            : (renderOption({
                id: -2,
                label: text('LBL_SCHOOL_NOT_FOUND'),
                subLabel: text('LBL_CONTACT_SCHOOL_ADMIN'),
                url: UNTIS_URL,
                className: 'link',
              }) as JSX.Element),
          searchPromptText: '',
          loadOptions: getSchools,
          arrowRenderer: () => renderSearch({ isOpen: isOpen && !isShort }),
          // loadOptions: (input: string) => {
          //   return new Promise((resolve) => {
          //     setTimeout(() => {
          //       resolve(getSchools(input));
          //     }, 300000);
          //   });
          // },
          filterOptions: filterSchools,
          onChange: selectSchool,
          optionRenderer: renderOption,
          clearable: true,
        }}
      />
      {renderOverlay()}
    </div>
  );
};

const filterSchools: FilterOptionsHandler<number> = (options: SchoolOption[]): SchoolOption[] => options;
const renderOption: OptionRendererHandler<number> = ({
  label,
  subLabel,
  url,
  lI,
  sLI,
  sLength,
}: SchoolOption): JSX.Element => {
  function renderLabel(label: string | undefined, i: number): React.ReactNode {
    if (!label || i === undefined || i < 0) {
      return label;
    }

    const first = label.substring(0, i);
    const term = label.substring(i, i + sLength);
    const last = label.substring(i + sLength, label.length);

    return (
      <span>
        {first}
        <mark>{term}</mark>
        {last}
      </span>
    );
  }

  return url ? (
    <a href={url} className={'search-option'}>
      <span>{renderLabel(label, lI)}</span>
      <small>{renderLabel(subLabel, sLI)}</small>
    </a>
  ) : (
    <span className={'search-option'}>
      <span className={'search-option-label'}>{label}</span>
      <small>{subLabel}</small>
    </span>
  );
};

const ClearRender = ({ onClick: handleClick }: { onClick?: () => void }) => {
  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (handleClick != null) {
      handleClick();
    }
  };

  return (
    // <Tooltip body={'Clear field'} position={'bottom'}>
    //   <div>
    <button className="clear-button" onClick={onClick} title="Clear field">
      <img src="img/icons/cross-circle.svg" onClick={handleClick} />
    </button>
    //   </div>
    // </Tooltip>
  );
};

const renderSearch = ({ isOpen }: { isOpen: boolean }): JSX.Element => {
  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <button className="search-button" onClick={onClick} style={{ zIndex: 1 }}>
      <img src="img/icons/search.svg" title="Search field" />
      {/* shadow overlay */}
      {isOpen && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            height: '5px',
            bottom: 0,
            left: 0,
            backgroundColor: '#fff',
            zIndex: 10000,
          }}
        />
      )}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/Search.tsx